import { render } from "./FeedbackDetailModal.vue?vue&type=template&id=426e7510&scoped=true"
import script from "./FeedbackDetailModal.vue?vue&type=script&lang=js"
export * from "./FeedbackDetailModal.vue?vue&type=script&lang=js"

import "./FeedbackDetailModal.vue?vue&type=style&index=0&id=426e7510&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426e7510"]])

export default __exports__